import { render, staticRenderFns } from "./StartClaim.vue?vue&type=template&id=57cd1699&scoped=true"
import script from "./StartClaim.vue?vue&type=script&lang=js"
export * from "./StartClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cd1699",
  null
  
)

export default component.exports